<template>
  <div>
    <upload-avatar
      @change="avatarChange"
      :loading="loading"
      :avatar="avatar"
      :avatarErrorMessage="form.$getError('avatar')"
    ></upload-avatar>

    <v-form ref="form" style="max-width: 400px">
      <label class="text-field-label pl-4">Name</label>
      <v-text-field
        flat
        solo
        required
        background-color="grey lighten-3"
        class="mt-2"
        v-model="form.full_name"
        :error-messages="form.$getError('full_name')"
      ></v-text-field>

      <label class="text-field-label pl-4">Email Address</label>
      <v-text-field
        flat
        solo
        required
        class="mt-2"
        background-color="grey lighten-3"
        v-model="form.email"
        :error-messages="form.$getError('email')"
      ></v-text-field>

      <label class="text-field-label pl-4">Password</label>
      <v-text-field
        flat
        solo
        required
        v-model="form.password"
        class="mt-2"
        background-color="grey lighten-3"
        @click:append="showEye = !showEye"
        :type="showEye ? 'text' : 'password'"
        :append-icon="showEye ? icons.eye : icons.eyeOff"
        :error-messages="form.$getError('password')"
      ></v-text-field>

      <label class="text-field-label pl-4">Confirm Password</label>
      <v-text-field
        flat
        solo
        required
        v-model="form.password_confirmation"
        class="mt-2"
        background-color="grey lighten-3"
        :type="showEye ? 'text' : 'password'"
        :error-messages="form.$getError('password_confirmation')"
      ></v-text-field>

      <v-btn
        color="success"
        depressed
        large
        class="mr-4"
        @click="onCreatePublisher"
        :loading="form.$busy"
      >Submit</v-btn>
    </v-form>

    <v-overlay absolute :value="loading" opacity="0.2">
      <v-progress-circular indeterminate color="primary" size="64"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar.show" right>
      {{ snackbar.message }}
      <v-btn color="pink" text @click="snackbar.show = false">Ok</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import {
  mdiChevronRight,
  mdiEye,
  mdiEyeOff
} from '@mdi/js'
import { mapActions } from 'vuex'
import UploadAvatar from './UploadAvatar'
import Form from '@/utils/form'

export default {
  name: 'PublisherForm',

  components: {
    UploadAvatar
  },

  data () {
    return {
      loading: false,
      showEye: false,
      form: {
        avatar: '',
        full_name: '',
        email: '',
        password: ''
      },
      avatar: null,
      icons: {
        arrow: mdiChevronRight,
        eye: mdiEye,
        eyeOff: mdiEyeOff
      },
      snackbar: {
        show: false,
        message: null
      }
    }
  },

  created () {
    this.form = new Form(this.form)
  },

  methods: {
    ...mapActions({
      createPublisher: 'publisher/createPublisher'
    }),

    onCreatePublisher () {
      let filteredData = this.filterFromData()

      this.form.$clearErrors()
      this.form.$busy = true
      this.loading = true

      this.createPublisher(filteredData)
        .then(response => {
          let publisher = response.data

          this.$refs.form.reset()

          this.$router.push({ name: 'publisher.details', params: { id: publisher.user.id } })
        }).catch(err => {
          this.form.$busy = false
          if (err.response.status === 422) {
            this.form.$setErrors(err.response.data.errors)
          }
        })

      this.loading = false
    },

    async avatarChange (image) {
      const imageUrl = URL.createObjectURL(image)

      this.form.avatar = image
      this.avatar = { url: imageUrl }
    },

    filterFromData () {
      let filterData = new FormData()

      filterData.append('avatar', this.form.avatar)
      filterData.append('full_name', this.form.full_name)
      filterData.append('email', this.form.email)
      filterData.append('password', this.form.password)
      filterData.append('password_confirmation', this.form.password_confirmation)

      return filterData
    }
  }
}
</script>
